import { useSubscription } from "@apollo/client";
import { gql } from "@apollo/client";
import {
  OrderStatusChangedSubscription,
  OrderStatusChangedSubscriptionVariables,
} from "../generated/graphql";

// 관리자 주문관리 페이지의 주문 상태가 바뀔 때마다 서버가 보내는 신호를 구독한다.
// 실제 데이터는 담겨있지 않고 "무언가 바뀌었다"는 신호만 오므로, 이 신호를 받으면
// 각 페이지에서 자신의 주문 목록 쿼리를 refetch해서 최신 상태로 맞추면 된다.
export const ORDER_STATUS_CHANGED_SUBSCRIPTION = gql`
  subscription orderStatusChanged {
    orderStatusChanged
  }
`;

export const useOrderStatusChangedSubscription = () => {
  return useSubscription<
    OrderStatusChangedSubscription,
    OrderStatusChangedSubscriptionVariables
  >(ORDER_STATUS_CHANGED_SUBSCRIPTION, {});
};
